// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAD1JREFUeNpiYGBgOADE%2F3Hgw0DM4IRHgSsDFOzFInmMAQnY49ONzZRjDFiADT7dMLALiE8y4AGW6LoBAgwAuIkf%2F%2FB7O9sAAAAASUVORK5CYII%3D", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.json-view {
  position: relative;
}
.json-view .collapser {
  width: 20px;
  height: 18px;
  display: block;
  position: absolute;
  left: -1.7em;
  top: -0.2em;
  z-index: 5;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center center;
  opacity: 0.5;
  cursor: pointer;
}
.json-view .collapsed {
  -ms-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -khtml-transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
.json-view .bl {
  display: block;
  padding-left: 20px;
  margin-left: -20px;
  position: relative;
}
.json-view {
  font-family: monospace;
}
.json-view ul {
  list-style-type: none;
  padding-left: 2em;
  border-left: 1px dotted;
  margin: 0.3em;
}
.json-view ul li {
  position: relative;
}
.json-view .dots,
.json-view .comments {
  display: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}
.json-view .comments {
  padding-left: 0.8em;
  font-style: italic;
  color: #888;
}
.json-view .null,
.json-view .num,
.json-view .bool,
.json-view .undef {
  font-weight: bold;
  color: #cacaca;
}
.json-view .str {
  color: #cacaca;
}
`, "",{"version":3,"sources":["webpack://./dist/static/lib/jsonView.less"],"names":[],"mappings":"AAEA;EACI,kBAAA;AADJ;AAIA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yDAAA;EACA,4BAAA;EACA,kCAAA;EACA,YAAA;EACA,eAAA;AAFJ;AAKA;EACI,6BAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,4BAAA;EACA,yBAAA;AAHJ;AAMA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAJJ;AAOA;EACI,sBAAA;AALJ;AAQA;EACI,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;AANJ;AASA;EACI,kBAAA;AAPJ;AAUA;;EAEI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;AARJ;AAWA;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;AATJ;AAYA;;;;EAII,iBAAA;EACA,cAAA;AAVJ;AAaA;EACI,cAAA;AAXJ","sourcesContent":["@import '../lib/colors.less';\n\n.json-view {\n    position: relative;\n}\n\n.json-view .collapser {\n    width: 20px;\n    height: 18px;\n    display: block;\n    position: absolute;\n    left: -1.7em;\n    top: -0.2em;\n    z-index: 5;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAD1JREFUeNpiYGBgOADE%2F3Hgw0DM4IRHgSsDFOzFInmMAQnY49ONzZRjDFiADT7dMLALiE8y4AGW6LoBAgwAuIkf%2F%2FB7O9sAAAAASUVORK5CYII%3D\");\n    background-repeat: no-repeat;\n    background-position: center center;\n    opacity: 0.5;\n    cursor: pointer;\n}\n\n.json-view .collapsed {\n    -ms-transform: rotate(-90deg);\n    -moz-transform: rotate(-90deg);\n    -khtml-transform: rotate(-90deg);\n    -webkit-transform: rotate(-90deg);\n    -o-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n}\n\n.json-view .bl {\n    display: block;\n    padding-left: 20px;\n    margin-left: -20px;\n    position: relative;    \n}\n\n.json-view {\n    font-family: monospace;\n}\n\n.json-view ul {\n    list-style-type: none;\n    padding-left: 2em;\n    border-left: 1px dotted;\n    margin: 0.3em;\n}\n\n.json-view ul li {\n    position: relative;\n}\n\n.json-view .dots,\n.json-view .comments {\n    display: none;\n    -moz-user-select: none; \n    -ms-user-select: none; \n    -khtml-user-select: none; \n    -webkit-user-select: none; \n    -o-user-select: none;     \n    user-select: none;\n}\n\n.json-view .comments {\n    padding-left: 0.8em;\n    font-style: italic;\n    color: #888;\n}\n\n.json-view .null,\n.json-view .num,\n.json-view .bool,\n.json-view .undef {\n    font-weight: bold;\n    color: @lightGrey;\n}\n\n.json-view .str {\n    color: @lightGrey;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
